import { NavLink } from "react-router-dom";
import { SearchBar } from "./SearchBar";
import { SyncStatus } from "./SyncStatus";
import { ThemeToggle } from "./ThemeToggle";

const links = [
  { to: "/", label: "Home", end: true, id: "nav-home" },
  { to: "/schedule", label: "Schedule", id: "nav-schedule" },
  { to: "/scores", label: "Scores", id: "nav-scores" },
  { to: "/standings", label: "Standings", id: "nav-standings" },
  { to: "/stats", label: "Stats", id: "nav-stats" },
  { to: "/weekly", label: "Weekly", id: "nav-weekly" },
  { to: "/compare", label: "Compare", id: "nav-compare" },
  { to: "/postseason", label: "Postseason", id: "nav-postseason" },
];

export const Navbar = () => {
  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-background border-b-2 border-border"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 flex items-center h-16">
        <NavLink to="/" data-testid="nav-logo" className="flex items-center gap-2 mr-8 shrink-0">
          <span className="w-3 h-8 bg-primary" />
          <span className="font-display text-3xl leading-none">
            GRID<span className="text-primary">IRON</span>
          </span>
        </NavLink>
        <div className="flex items-center gap-1 sm:gap-2 overflow-x-auto">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.id}
              className={({ isActive }) =>
                `px-3 sm:px-4 py-2 text-sm font-semibold uppercase tracking-wider whitespace-nowrap border-b-2 transition-colors duration-150 ${
                  isActive
                    ? "border-primary text-primary"
                    : "border-transparent text-muted-foreground hover:text-foreground"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>
        <div className="ml-auto flex items-center gap-3 shrink-0">
          <SearchBar />
          <ThemeToggle />
          <SyncStatus />
        </div>
      </div>
    </nav>
  );
};
